import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { Link } from "react-router-dom";
import L from "leaflet";

const mk = (cls: string) => L.divIcon({ className: "", html: `<div class="wn-pin ${cls}"><span></span></div>`, iconSize: [36, 44], iconAnchor: [18, 42], popupAnchor: [0, -40] });
const venuePin = mk("");
const spotPin = mk("wn-pin-spot");

export type MapPoint = { id: string; kind: "spot" | "venue"; lat: number; lng: number; name: string; to: string };

export const ExploreMap = ({ points, className = "h-[60vh]" }: { points: MapPoint[]; className?: string }) => {
  const pts = points.filter((p) => typeof p.lat === "number" && typeof p.lng === "number");
  const bounds = pts.length > 1 ? L.latLngBounds(pts.map((p) => [p.lat, p.lng] as [number, number])).pad(0.2) : undefined;
  const center: [number, number] = pts.length === 1 ? [pts[0].lat, pts[0].lng] : [33.3152, 44.3661];
  return (
    <div dir="ltr" className={`relative z-0 overflow-hidden rounded-3xl border ${className}`} data-testid="explore-map">
      <MapContainer key={pts.map((p) => p.id).join(",")} center={center} zoom={pts.length === 1 ? 14 : 6} bounds={bounds} scrollWheelZoom className="h-full w-full">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {pts.map((p) => (
          <Marker key={p.kind + p.id} position={[p.lat, p.lng]} icon={p.kind === "spot" ? spotPin : venuePin} zIndexOffset={p.kind === "spot" ? 1000 : 0}>
            <Popup><Link to={p.to} data-testid={`map-popup-${p.id}`} className="font-bold" dir="auto">{p.name}</Link></Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};
